module.exports = __webpack_public_path__ + "img/madrid.e1f4a30b.png";